import { observable, action, runInAction } from 'mobx'
import remotedev from 'mobx-remotedev'
import { StoreExt } from '@utils/reactExt'

import { commonSettings } from '@services/api'

export class commonSettingsStore extends StoreExt {
    @observable loading = false
    @observable list = {}
    @observable errors = {}

    @action
    getList = async () => {
        this.loading = true
        const { data } = await commonSettings.getList()
        const pairList = {}
        data.map(item => (pairList[item.key] = item.value))
        runInAction(() => {
            this.list = { ...pairList }
            this.loading = false
        })
    }
}

export default remotedev(new commonSettingsStore())
